import { defaultLocale, locales } from '@/constants/locale';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useChangeLocale = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  const changeLocale = (locale: string) => {
    // Resolve case-insensitively so an invite link's ?locale= param maps to a
    // supported bundle regardless of casing — both the BCP 47 form sent today
    // (e.g. 'zh-TW') and legacy lowercase links already in sent emails
    // (e.g. 'zh-tw') resolve to the same bundle. (CR-228)
    const validLocale =
      locales.find(
        supported => supported.toLowerCase() === locale.toLowerCase(),
      ) ?? defaultLocale;

    // Change i18n language
    i18n.changeLanguage(validLocale);
    localStorage.setItem('language', validLocale);

    // Update URL to reflect new locale
    const currentPathParts = location.pathname.split('/');
    currentPathParts[1] = validLocale; // Replace the language part
    const newPath = currentPathParts.join('/') + location.search;

    navigate(newPath, { replace: true });
  };

  return changeLocale;
};
